export default function HoverFace() {
  return (
    <img
      src={process.env.PUBLIC_URL + "/images/35immacolataHover.jpg"}
      alt=""
    />
  );
}
